/* Boxi zieht bei dir ein – sections/bxi-boxi.liquid (21.10.2026, Feedback 27.10.2026)
   Reiter Classics/Coffee Club, Kaffee-Auswahl, Live-Preise der Abo-Karten, Zeichenzähler,
   Album zum Umdrehen, Paketschein mit Foto-Upload (nur mit Upload-Adresse).
   Weglot: Das Skript schreibt nur Zahlen und Preise in .notranslate-Spans. */
(function () {
  function initRoot(root) {
    if (root.dataset.bxiReady) return;
    root.dataset.bxiReady = '1';
    root.classList.add('is-js');

    /* Reiter */
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-bxi-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-bxi-panel]'));
    function show(key, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-bxi-tab') === key;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-bxi-panel') !== key; });
    }
    if (tabs.length && panels.length) {
      var start = 'classics';
      var hash = (window.location.hash || '').replace('#', '');
      var param = '';
      try { param = new URLSearchParams(window.location.search).get('abo') || ''; } catch (e) {}
      if (hash === 'coffee-club' || param === 'coffee-club' || param === 'club') start = 'club';
      show(start, false);
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(t.getAttribute('data-bxi-tab'), false); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          show(next.getAttribute('data-bxi-tab'), true);
        });
      });
      window.addEventListener('hashchange', function () {
        var h = (window.location.hash || '').replace('#', '');
        if (h === 'coffee-club') show('club', false);
        if (h === 'classics') show('classics', false);
      });
    }

    /* Abo-Karten */
    Array.prototype.slice.call(root.querySelectorAll('.bxi-abo-form')).forEach(function (form) {
      var jsonEl = form.querySelector('[data-bxi-json]');
      var vSel = form.querySelector('[data-bxi-variant]');
      var pSel = form.querySelector('[data-bxi-plan]');
      if (!jsonEl || !vSel || !pSel) return;
      var data;
      try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      var def = pSel.getAttribute('data-default');
      if (def && pSel.querySelector('option[value="' + def + '"]')) pSel.value = def;
      var priceEl = form.querySelector('[data-bxi-price]');
      var wasWrap = form.querySelector('[data-bxi-was-wrap]');
      var wasEl = form.querySelector('[data-bxi-was]');
      var saveEl = form.querySelector('[data-bxi-save]');
      var btn = form.querySelector('button[type="submit"]');
      function update() {
        var v = null;
        for (var i = 0; i < data.v.length; i++) { if (String(data.v[i].id) === vSel.value) { v = data.v[i]; break; } }
        if (!v) return;
        var sp = v.sp && v.sp[pSel.value];
        if (priceEl) priceEl.textContent = sp ? sp.p : v.p;
        var showSave = !!(sp && sp.o > 0);
        if (wasWrap) wasWrap.hidden = !showSave;
        if (saveEl) saveEl.hidden = !showSave;
        if (showSave) {
          if (wasEl) wasEl.textContent = sp.c;
          if (saveEl) saveEl.textContent = '−' + sp.o + ' %';
        }
        if (btn) btn.disabled = !v.a;
      }
      vSel.addEventListener('change', update);
      pSel.addEventListener('change', update);
      update();
    });

    /* Zeichenzähler */
    Array.prototype.slice.call(root.querySelectorAll('[data-bxi-count]')).forEach(function (ta) {
      var out = root.querySelector('[data-bxi-left]');
      var max = parseInt(ta.getAttribute('maxlength'), 10) || 600;
      function count() { if (out) out.textContent = String(max - ta.value.length); }
      ta.addEventListener('input', count);
      count();
    });

    /* Kaffee-Auswahl: eine Karte statt mehrerer */
    Array.prototype.slice.call(root.querySelectorAll('[data-bxi-pick]')).forEach(function (pick) {
      var opts = Array.prototype.slice.call(pick.querySelectorAll('[data-bxi-pick-opt]'));
      var panel = pick.parentNode;
      var cards = Array.prototype.slice.call(panel.querySelectorAll('[data-bxi-card]'));
      function select(id, focus) {
        opts.forEach(function (o) {
          var on = o.getAttribute('data-bxi-pick-opt') === id;
          o.setAttribute('aria-checked', on ? 'true' : 'false');
          o.tabIndex = on ? 0 : -1;
          if (on && focus) o.focus();
        });
        cards.forEach(function (c) { c.hidden = c.getAttribute('data-bxi-card') !== id; });
      }
      if (!opts.length) return;
      select(opts[0].getAttribute('data-bxi-pick-opt'), false);
      opts.forEach(function (o, i) {
        o.addEventListener('click', function () { select(o.getAttribute('data-bxi-pick-opt'), false); });
        o.addEventListener('keydown', function (e) {
          var k = e.key;
          if (k !== 'ArrowRight' && k !== 'ArrowDown' && k !== 'ArrowLeft' && k !== 'ArrowUp') return;
          e.preventDefault();
          var step = (k === 'ArrowRight' || k === 'ArrowDown') ? 1 : opts.length - 1;
          select(opts[(i + step) % opts.length].getAttribute('data-bxi-pick-opt'), true);
        });
      });
    });

    /* Album: antippen oder Knopf dreht das Foto um */
    Array.prototype.slice.call(root.querySelectorAll('[data-bxi-flip]')).forEach(function (card) {
      var btn = card.querySelector('[data-bxi-flip-btn]');
      function toggle() {
        var on = !card.classList.contains('is-flipped');
        card.classList.toggle('is-flipped', on);
        if (btn) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      card.addEventListener('click', function (e) {
        if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches && e.target !== btn && !(btn && btn.contains(e.target))) return;
        toggle();
      });
    });

    /* Paketschein mit Foto */
    var form = root.querySelector('#bxi-album-form');
    var uploadUrl = form ? (form.getAttribute('data-bxi-upload') || '').trim() : '';
    if (form && uploadUrl) {
      var fileIn = form.querySelector('[data-bxi-photo]');
      var drop = form.querySelector('[data-bxi-drop]');
      var thumb = form.querySelector('[data-bxi-thumb]');
      var fname = form.querySelector('[data-bxi-photo-name]');
      var done = form.querySelector('[data-bxi-done]');
      var fail = form.querySelector('[data-bxi-fail]');
      var send = form.querySelector('[data-bxi-send]');
      var mail = (root.querySelector('.bxi-mail') || {}).textContent || 'info@19grims.com';
      var MAX = 1600;
      function setFail(msg) { if (fail) { fail.textContent = msg; fail.hidden = !msg; } }
      if (fileIn) {
        fileIn.addEventListener('change', function () {
          var f = fileIn.files && fileIn.files[0];
          setFail('');
          if (!f) { if (thumb) thumb.hidden = true; if (fname) fname.textContent = 'Foto auswählen'; if (drop) drop.classList.remove('is-set'); return; }
          if (!/^image\//.test(f.type)) { setFail('Das ist kein Foto. Bitte nimm ein JPG oder PNG.'); fileIn.value = ''; return; }
          if (fname) fname.textContent = f.name.length > 40 ? f.name.slice(0, 37) + '…' : f.name;
          if (drop) drop.classList.add('is-set');
          if (thumb && window.URL) { thumb.style.backgroundImage = 'url(' + URL.createObjectURL(f) + ')'; thumb.hidden = false; }
        });
      }
      function shrink(file) {
        return new Promise(function (resolve, reject) {
          var url = URL.createObjectURL(file);
          var img = new Image();
          img.onload = function () {
            var w = img.naturalWidth, h = img.naturalHeight, k = Math.min(1, MAX / Math.max(w, h));
            var c = document.createElement('canvas');
            c.width = Math.round(w * k); c.height = Math.round(h * k);
            var ctx = c.getContext('2d');
            ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, c.width, c.height);
            ctx.drawImage(img, 0, 0, c.width, c.height);
            URL.revokeObjectURL(url);
            resolve(c.toDataURL('image/jpeg', 0.85).split(',')[1]);
          };
          img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('decode')); };
          img.src = url;
        });
      }
      function val(sel) { var el = form.querySelector(sel); return el ? (el.type === 'checkbox' ? el.checked : el.value) : ''; }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        setFail('');
        if (!form.reportValidity || form.reportValidity()) {
          var f = fileIn && fileIn.files && fileIn.files[0];
          if (!f) { setFail('Bitte wähl ein Foto aus.'); return; }
          if (f.size > 25 * 1024 * 1024) { setFail('Das Foto ist zu groß. Maximal 25 MB.'); return; }
          form.classList.add('is-busy');
          if (send) { send.dataset.label = send.dataset.label || send.textContent; send.textContent = 'Wird verschickt …'; }
          shrink(f).then(function (b64) {
            var payload = {
              image: b64, name: val('#bxi-name'), email: val('#bxi-email'), wann: val('#bxi-era'), text: val('#bxi-text'),
              ok_publish: !!val('#bxi-ok-publish'), ok_rights: !!val('#bxi-ok-rights'), ok_age: !!val('#bxi-ok-age'),
              website: val('[data-bxi-hp]'), page: window.location.pathname
            };
            return fetch(uploadUrl, { method: 'POST', body: JSON.stringify(payload) });
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (!res || !res.ok) throw new Error((res && res.error) || 'server');
            form.reset();
            Array.prototype.slice.call(form.querySelectorAll('[data-bxi-count]')).forEach(function (el) { el.dispatchEvent(new Event('input')); });
            if (thumb) thumb.hidden = true;
            if (fname) fname.textContent = 'Foto auswählen';
            if (drop) drop.classList.remove('is-set');
            if (done) { done.hidden = false; done.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
          }).catch(function (err) {
            var m = String(err && err.message || '');
            if (m === 'decode') setFail('Das Foto konnten wir nicht lesen. Versuch ein JPG oder PNG.');
            else if (m === 'rate') setFail('Du hast heute schon einige Fotos geschickt. Danke! Morgen geht wieder was.');
            else setFail('Das hat nicht geklappt. Versuch es gleich nochmal oder schick dein Foto an ' + mail + '.');
          }).then(function () {
            form.classList.remove('is-busy');
            if (send && send.dataset.label) send.textContent = send.dataset.label;
          });
        }
      });
    }
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('.bxi')).forEach(initRoot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { boot(); });
})();
